import axios from "axios";
import config from "../../config";
import keycloak from "../../keycloak";
import {showError} from "../notification/ToastManager";

axios.defaults.withCredentials = true
export const verifyDcActionsExistance = async (dcId) => {
    var res = [];
    try {
        await axios.get(config.BACK_URL + "/dcAction/verify-existance/" + encodeURIComponent(dcId), {
            headers: {
                'Authorization': 'Bearer ' + keycloak.token
            }
        }).then(response => {
            res = response.data.content;
        })
    } catch (e) {
        showError("Error", "An error was occurred when verifying data collection actions existance");
    }
    return res;
}